import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Briefcase, Search } from 'lucide-react';

export default function RoleChoice() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center px-4">
      <div className="max-w-4xl w-full">
        {/* Logo */}
        <div className="text-center mb-12">
          <h1 className="text-6xl font-bold tracking-tight mb-2">
            <span className="bg-gradient-to-r from-blue-600 via-indigo-600 to-blue-700 bg-clip-text text-transparent">
              Trab
            </span>
            <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-blue-600 bg-clip-text text-transparent">
              adju
            </span>
          </h1>
          <p className="text-xs text-gray-500 tracking-widest uppercase">Cabo Verde</p>
          <p className="text-xl text-gray-600 mt-4">{t('roleChoice.subtitle')}</p>
        </div>

        {/* Choice Cards */}
        <div className="grid md:grid-cols-2 gap-6">
          {/* Candidate Card */}
          <Card 
            className="p-8 hover:shadow-2xl transition-all cursor-pointer border-2 hover:border-blue-500"
            onClick={() => navigate('/candidate/register')}
            data-testid="candidate-choice"
          >
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full mb-6">
                <Search className="h-10 w-10 text-white" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                {t('roleChoice.candidate')}
              </h2>
              <p className="text-gray-600 mb-6">
                {t('roleChoice.candidateDesc')}
              </p>
              <Button className="w-full bg-blue-600 hover:bg-blue-700">
                Começar Agora
              </Button>
            </div>
          </Card>

          {/* Employer Card */}
          <Card 
            className="p-8 hover:shadow-2xl transition-all cursor-pointer border-2 hover:border-indigo-500"
            onClick={() => navigate('/register')}
            data-testid="employer-choice"
          >
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full mb-6">
                <Briefcase className="h-10 w-10 text-white" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                {t('roleChoice.employer')}
              </h2>
              <p className="text-gray-600 mb-6">
                {t('roleChoice.employerDesc')}
              </p>
              <Button className="w-full bg-indigo-600 hover:bg-indigo-700">
                Começar Agora
              </Button>
            </div>
          </Card>
        </div>

        {/* Login Links */}
        <div className="mt-8 text-center text-sm text-gray-600">
          <span>Já tem conta? </span>
          <button 
            onClick={() => navigate('/candidate/login')}
            className="text-blue-600 hover:text-blue-700 font-medium"
          >
            Login Candidato
          </button>
          <span className="mx-2">|</span>
          <button 
            onClick={() => navigate('/login')}
            className="text-indigo-600 hover:text-indigo-700 font-medium"
          >
            Login Empregador
          </button>
        </div>
      </div>
    </div>
  );
}
